module.exports = __webpack_public_path__ + "img/bg-support-hero.e7e8bf57.jpg";